import React from 'react';
import ServicesProvider from '../global/services/ServicesProvider';
import 'BRAND_THEME_IMPORT_PATH';
import 'BRAND_FONTS_IMPORT_PATH';
import '../assets/scss/main.scss';
import Root from './Root';
import { ApplicationInsightsWrapper } from './applicationInsights/ApplicationInsightsWrapper';
import { QueryProviderWrapper } from './QueryProviderWrapper';
import { NotificationContextProvider } from '../context/notification/NotificationProvider';
import GlobalizationProvider from '../context/globalization/GlobalizationProvider';
import { globalizationSetup } from '../config/globalization/globalizationSetup';
import { SearchProvider } from '../context/search/SearchProvider';
import { ViewsProvider } from '../context/view/ViewsProvider';
import { DocumentsProvider } from '../context/documents/DocumentsProvider';
import { CurrentUserProvider } from '../context/currentUser/CurrentUserProvider';
import { UiAdminConfigsProvider } from '../context/uiAdminConfigs/UiAdminConfigsProvider';
import { MsGraphProvider } from '../context/msGraph/MsGraphProvider';
import { LoaderProvider } from '../context/loader/GearLoaderProvider';
import { DocumentFormProvider } from '../context/form/DocumentFormProvider';
import { ThemeProvider } from '../context/theme/ThemeContext';
import { BrowserGuard } from './BrowserGuard';
import { dayjsSetup } from '../helpers/DayJsHelper';

const App: React.FC = () => {
  React.useEffect(() => {
    dayjsSetup();
    globalizationSetup();
  }, []);
  return (
    <ApplicationInsightsWrapper>
      <ServicesProvider>
        <ThemeProvider>
          <DocumentFormProvider>
            <NotificationContextProvider>
              <QueryProviderWrapper>
                <GlobalizationProvider>
                  <div className="app">
                    <CurrentUserProvider>
                      <LoaderProvider>
                        <MsGraphProvider>
                          <SearchProvider>
                            <ViewsProvider>
                              <DocumentsProvider>
                                <UiAdminConfigsProvider>
                                  <BrowserGuard>
                                    <Root />
                                  </BrowserGuard>
                                </UiAdminConfigsProvider>
                              </DocumentsProvider>
                            </ViewsProvider>
                          </SearchProvider>
                        </MsGraphProvider>
                      </LoaderProvider>
                    </CurrentUserProvider>
                  </div>
                </GlobalizationProvider>
              </QueryProviderWrapper>
            </NotificationContextProvider>
          </DocumentFormProvider>
        </ThemeProvider>
      </ServicesProvider>
    </ApplicationInsightsWrapper>
  );
};

export default App;
